import {
  HomeApi,
  PageContentPydanticModel,
  PostContentPydanticModel,
  StreamContentPydanticModel,
  VideoContentPydanticModel,
} from "@virtualprogaming/js-public-sdk";
import { useMemo } from "react";
import { useQuery, UseQueryOptions } from "react-query";

import { useApiConfig } from "~/utils";

export function useHomeApi() {
  const config = useApiConfig();
  return useMemo(() => new HomeApi(...config), [config]);
}

export function useHomeNews(
  options?: UseQueryOptions<PostContentPydanticModel[]>
) {
  const api = useHomeApi();
  return useQuery({
    queryKey: ["home", "news"],
    queryFn: async () => {
      const { data } = await api.getNews();
      return data;
    },
    ...options,
  });
}

export function useHomeNewsById(
  id: string,
  options?: UseQueryOptions<PostContentPydanticModel>
) {
  const api = useHomeApi();
  return useQuery({
    queryKey: ["home", "news", id],
    queryFn: async () => {
      const { data } = await api.getNewsById(id);
      return data;
    },
    ...options,
  });
}

export function useHomeVideos(
  options?: UseQueryOptions<VideoContentPydanticModel[]>
) {
  const api = useHomeApi();
  return useQuery({
    queryKey: ["home", "videos"],
    queryFn: async () => {
      const { data } = await api.getVideos();
      return data;
    },
    ...options,
  });
}

export function useHomePages(
  options?: UseQueryOptions<PageContentPydanticModel[]>
) {
  const api = useHomeApi();
  return useQuery({
    queryKey: ["home", "pages"],
    queryFn: async () => {
      const { data } = await api.getPages();
      return data;
    },
    ...options,
  });
}

export function useHomePage(
  id: string,
  options?: UseQueryOptions<PageContentPydanticModel>
) {
  const api = useHomeApi();
  return useQuery({
    queryKey: ["home", "pages", id],
    queryFn: async () => {
      const { data } = await api.getPageById(id);
      return data;
    },
    ...options,
  });
}

export function useHomeStreams(
  options?: UseQueryOptions<StreamContentPydanticModel[]>
) {
  const api = useHomeApi();

  return useQuery({
    queryKey: ["home", "streams"],
    queryFn: async () => {
      const { data } = await api.getStreams(true);
      return data;
    },
    ...options,
  });
}

export function useStreams(
  options?: UseQueryOptions<StreamContentPydanticModel[]>
) {
  const api = useHomeApi();

  return useQuery({
    queryKey: ["streams"],
    queryFn: async () => {
      const { data } = await api.getStreams(true);
      return data;
    },
    ...options,
    refetchInterval: 60000,
  });
}
